import * as React from 'react';
import './ProfileIndex.css';

export interface ProfileCardComponentProps {
  id: number;
  name?: string;
  juridical: boolean;
  isDefaultProfile: boolean;
  handleEdit: () => void;
}

const ProfileCardComponent: React.StatelessComponent<ProfileCardComponentProps> = (
  props: ProfileCardComponentProps) => (
    <div className="col-xs-6 col-md-6 col-lg-4">
      <div className="simple-card tab">
        <a className="btn-menu btn-circle-user">
          <span className={'circle' + (props.isDefaultProfile ? '' : ' circle-grey')}>
            {props.name && props.name[0] + (props.name.split(/[^A-Za-z]/)[1] ?
              props.name.split(/[^A-Za-z]/)[1][0] : '')}
          </span>
        </a>
        <h4 className="deco-title f-s-16">
          {props.name}
          <br />
          <span className="primary-font f-w-100 italic">
            {props.juridical ?
              'Persona Jurídica' :
              'Persona Física'}
          </span>
        </h4>
        <div className="row">
          <div className="col-xs-7">
            {props.isDefaultProfile ?
              <p className="padding-left-20">
                <span className="default" />
                <strong className="default-profile">
                  Perfil
                  <br />
                  <span className="">
                    predeterminado
                </span>
                </strong>
              </p> :
              null}
          </div>
          <div className="col-xs-5">
            <div className="gap-10" />
            <p className="text-right">
              <button
                className="btn btn-primary-color"
                onClick={props.handleEdit}
              >
                Editar
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );

export default ProfileCardComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/my-profile-index/partials/ProfileCard.component.tsx